import { getPrices, getResellerPrices, RawPrices } from '../../api/admin';
import { Money } from '../../utils/currency';
import invalidationManager from './InvalidationManager';

export type ResellerPrices = {
  subscriptions: {
    [subscriptionId: string]: {
      price: Money;
      discount: number;
      taxRate: number;
    };
  };
  recurring: {
    [recurringId: string]: {
      price: Money;
      discount: number;
      taxRate: number;
    };
  };
};

const unpackPrices = (prices: RawPrices): ResellerPrices => {
  return {
    subscriptions: {
      PLUS: {
        ...prices.subscriptions.PLUS,
        price: new Money(prices.subscriptions.PLUS.price),
      },
      RESTAURANT: {
        ...prices.subscriptions.RESTAURANT,
        price: new Money(prices.subscriptions.RESTAURANT.price),
      },
      RETAIL: {
        ...prices.subscriptions.RETAIL,
        price: new Money(prices.subscriptions.RETAIL.price),
      },
      ENKLA_ORDER: {
        ...prices.subscriptions.ENKLA_ORDER,
        price: new Money(prices.subscriptions.ENKLA_ORDER.price),
      },
      USER_PERMISSIONS: {
        ...prices.subscriptions.USER_PERMISSIONS,
        price: new Money(prices.subscriptions.USER_PERMISSIONS.price),
      },
      PERSONALKOLLEN: {
        ...prices.subscriptions.PERSONALKOLLEN,
        price: new Money(prices.subscriptions.PERSONALKOLLEN.price),
      },
      FORTNOX_INVOICE: {
        ...prices.subscriptions.FORTNOX_INVOICE,
        price: new Money(prices.subscriptions.FORTNOX_INVOICE.price),
      },
      BOOKKEEPING: {
        ...prices.subscriptions.BOOKKEEPING,
        price: new Money(prices.subscriptions.BOOKKEEPING.price),
      },
      EXTERNAL_SEARCH: {
        ...prices.subscriptions.EXTERNAL_SEARCH,
        price: new Money(prices.subscriptions.EXTERNAL_SEARCH.price),
      },
    },
    recurring: {
      NETS_TERMINAL: {
        ...prices.recurring.NETS_TERMINAL,
        price: new Money(prices.recurring.NETS_TERMINAL.price),
      },
      TIDYPAY_TERMINAL: {
        ...prices.recurring.TIDYPAY_TERMINAL,
        price: new Money(prices.recurring.TIDYPAY_TERMINAL.price),
      },
    },
  };
};

const { hook: usePrices } = invalidationManager.createFetcher({
  queryKey: () => ['prices'],
  fetchFunction: async () => {
    return getPrices().then((prices) => {
      return unpackPrices(prices);
    });
  },
});

const { hook: useResellerPrices } = invalidationManager.createFetcher({
  queryKey: (resellerId: string) => ['reseller-prices', resellerId],
  fetchFunction: async (resellerId: string) => {
    if (!resellerId) {
      return null;
    }
    return getResellerPrices(resellerId).then((prices) => {
      return unpackPrices(prices);
    });
  },
});

export { usePrices, useResellerPrices };
